import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import './style.scss';

class PageLoading extends Component {
  static propTypes = {
    className: PropTypes.string,
    noRetry: PropTypes.bool,
  };

  static defaultProps = {
    className: null,
    noRetry: false,
  };

  constructor(props) {
    super(props);

    this.removeDataEvent = null;

    this.isPending = false;

    this.state = {
      isRetry: false,
    };
  }

  componentDidMount() {
    const { noRetry } = this.props;
    if (noRetry) {
      return;
    }

    this.timeout = setTimeout(() => {
      this.setState({ isRetry: true });
    }, 5000);

    this.removeDataEvent = window.ci.on('data', this.reload);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);

    this.removeDataEvent && this.removeDataEvent();
  }

  checkReload = () => {
    if (this.isPending) {
      return;
    }

    this.isPending = true;

    window.ci.web.data('firebaseIdToken');

    setTimeout(() => {
      window.location.reload();
    }, 5000);
  };

  reload = (e) => {
    if (!this.isPending) {
      return;
    }

    const { key } = e.detail;
    if (key === 'firebaseIdToken') {
      window.location.reload();
    }
  };

  render() {
    const { className, noRetry } = this.props;

    const { isRetry } = this.state;

    return (
      <div className={className} styleName="page-loading">
        <div styleName="page-loading-box">
          <div styleName="dot-wrap">
            <div styleName="dot" />
            <div styleName="dot" />
            <div styleName="dot" />
          </div>
        </div>
        {!noRetry && isRetry && (
          <button styleName="retry" onClick={this.checkReload}>
            재시도 하기
          </button>
        )}
      </div>
    );
  }
}

export default PageLoading;



// WEBPACK FOOTER //
// ./src/app/components/common/PageLoading/index.jsx